import Keycloak from 'keycloak-js'
import Api from '../../../common/http/Api'
import { UsersDto } from './dto/get/UsersDto'
import User from '../../../domain/user/User'
import Users from '../../../domain/user/Users'
import CreateUser from '../../../domain/user/CreateUser'
import { UserDto } from './dto/get/UserDto'
import { UUID } from 'crypto'
import UpdateStudent from '../../../domain/user/UpdateStudent'

class UserApi extends Api {
  private static readonly BASIC_PATH = 'users'

  static login = async (keycloak: Keycloak): Promise<any> => {
    return await Api.put(`${UserApi.BASIC_PATH}/login`, {}, keycloak)
  }

  static fetchUsers = async (keycloak: Keycloak): Promise<Users> => {
    const usersDto: UsersDto = await Api.get(UserApi.BASIC_PATH, keycloak)
    return Users.fromDto(usersDto)
  }

  static fetchUser = async (
    keycloak: Keycloak,
    userId: UUID,
  ): Promise<User> => {
    const path = `${UserApi.BASIC_PATH}/${userId}`

    const userDto: UserDto = await Api.get(path, keycloak)
    return User.fromDto(userDto)
  }

  static createStudent = async (
    keycloak: Keycloak,
    createUser: CreateUser,
  ): Promise<User> => {
    const createStudentDto = createUser.toStudentDto()
    const path = `${UserApi.BASIC_PATH}/students`

    const data = await Api.post(path, createStudentDto, keycloak)
    const userDto: UserDto = data

    const user = User.fromDto(userDto)

    if (user == null) {
      // TODO: Error handling better...
      throw Error("Can't create user")
    }

    return user
  }

  static updateStudent = async (
    keycloak: Keycloak,
    studentId: UUID,
    updateStudent: UpdateStudent,
  ): Promise<User> => {
    const updateStudentDto = updateStudent.toDto()
    const path = `${UserApi.BASIC_PATH}/students/${studentId}`

    const data = await Api.put(path, updateStudentDto, keycloak)
    const userDto: UserDto = data

    const user = User.fromDto(userDto)

    if (user == null) {
      // TODO: Error handling better...
      throw Error("Can't create user")
    }

    return user
  }

  static removeStudent = async (
    keycloak: Keycloak,
    studentId: UUID,
  ): Promise<void> => {
    const path = `${UserApi.BASIC_PATH}/students/${studentId}`
    await Api.delete(path, keycloak)
  }
}

export default UserApi
